const dateTimeFormatter = new Intl.DateTimeFormat('en-GB', {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  hour12: true,
});

const dateOnlyFormatter = new Intl.DateTimeFormat('en-GB', {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
});

const toSafeDate = (value?: string | Date | null) => {
  if (!value) return null;
  const parsed = value instanceof Date ? value : new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const normalizeMeridiem = (value: string) => value.replace(/\b(am|pm)\b/g, (token) => token.toUpperCase());

export const formatLocalDateTime = (value?: string | Date | null, fallback = '—') => {
  const parsed = toSafeDate(value);
  if (!parsed) return fallback;
  return normalizeMeridiem(dateTimeFormatter.format(parsed));
};

export const formatLocalDate = (value?: string | Date | null, fallback = '—') => {
  const parsed = toSafeDate(value);
  if (!parsed) return fallback;
  return dateOnlyFormatter.format(parsed);
};

